// PipelineFeatures.js
import { useEffect, useRef, useState } from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DraggableFeatureList from "../../../components/UI/DraggableFeatureList";
import { useSettings } from "../../../context/SettingsContext";
import { addUid } from "../../../utils/featureUid";

export default function PipelineFeatures({ data }) {
  const [features, setFeatures] = useState([]);
  const { updatePipelineFeatures } = useSettings();

  const hydrated = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    if (!data || hydrated.current) return;

    // ensure UID + correct order assigned
    setFeatures(
      (data || []).map((f, index) =>
        addUid({
          ...f,
          order: f.order ?? index, // FIX: ensure order exists
        })
      )
    );

    hydrated.current = true;
  }, [data]);

  const toggle = (uid, field = "enabled", value) => {
    dirty.current = true;

    setFeatures((prev) =>
      prev.map((i) =>
        i.uid === uid ? { ...i, [field]: value ?? !i[field] } : i
      )
    );
  };

  const reorder = (column, newOrderIds) => {
    dirty.current = true;

    setFeatures((prev) =>
      prev.map((item) => {
        if (item.position !== column) return item;

        return {
          ...item,
          order: newOrderIds.indexOf(item.uid),
        };
      })
    );
  };

  useEffect(() => {
    if (!dirty.current) return;

    updatePipelineFeatures(features.map(({ uid, ...rest }) => rest));
  }, [features]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 2.5 }}>
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>
          Pipeline Profile Layout
        </Typography>
        <Tooltip title="Configure the layout of the pipeline profile page" arrow>
          <InfoOutlinedIcon sx={{ fontSize: 16, color: "#94a3b8", cursor: "pointer" }} />
        </Tooltip>
      </Box>

      <DraggableFeatureList
        items={features}
        getId={(i) => i.uid}
        onToggle={toggle}
        onReorder={reorder}
      />
    </Box>
  );
}
